module.exports = __webpack_public_path__ + "img/shm_logo_SNB.610eed82.svg";